"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Backdrop = _interopRequireDefault(require("../Backdrop"));
var _Box = _interopRequireDefault(require("../Box"));
var _Fade = _interopRequireDefault(require("../Fade"));
var _Modal = require("../Modal");
var _transitions = require("../styles/transitions");
var _tss = require("../styles/tss");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["BackdropProps", "BoxProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsDialog',
  uniqId: 'v1Ag6h'
})((theme, _params, classes) => ({
  /* Styles applied to the root element. */
  root: {
    '@media print': {
      // Use !important to override the Modal inline-style.
      position: 'absolute !important'
    }
  },
  /* Styles applied to the container element if `scroll="box"`. */
  scrollBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  /* Styles applied to the container element if `scroll="body"`. */
  scrollBody: {
    overflowY: 'auto',
    overflowX: 'hidden',
    textAlign: 'center',
    '&:after': {
      content: '""',
      display: 'inline-block',
      verticalAlign: 'middle',
      height: '100%',
      width: '0'
    }
  },
  /* Styles applied to the container element. */
  container: {
    height: '100%',
    '@media print': {
      height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  },
  /* Styles applied to the `Box` component. */
  box: {
    borderRadius: theme.busbud.styles.rounding.xl,
    margin: theme.busbud.spacing(6, 3),
    position: 'relative',
    overflowY: 'auto',
    // Fix IE 11 issue, to remove at some point.
    '@media print': {
      overflowY: 'visible',
      boxShadow: 'none'
    }
  },
  /* Styles applied to the `Box` component if `scroll="box"`. */
  boxScrollBox: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
  },
  /* Styles applied to the `Box` component if `scroll="body"`. */
  boxScrollBody: {
    display: 'inline-block',
    verticalAlign: 'middle',
    textAlign: 'left' // 'initial' doesn't work on IE 11
  },
  /* Styles applied to the `Box` component if `maxWidth=false`. */
  boxWidthFalse: {
    maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
  },
  /* Styles applied to the `Box` component if `maxWidth="xs"`. */
  boxWidthXs: {
    maxWidth: Math.max(theme.busbud.breakpoints.values.xs, 444),
    [`&.${classes.boxScrollBody}`]: {
      [theme.busbud.breakpoints.down(Math.max(theme.busbud.breakpoints.values.xs, 444) + theme.busbud.space.base * 3 * 2)]: {
        maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
      }
    }
  },
  /* Styles applied to the `Box` component if `maxWidth="sm"`. */
  boxWidthSm: {
    maxWidth: theme.busbud.breakpoints.values.sm,
    [`&.${classes.boxScrollBody}`]: {
      [theme.busbud.breakpoints.down(theme.busbud.breakpoints.values.sm + theme.busbud.space.base * 3 * 2)]: {
        maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
      }
    }
  },
  /* Styles applied to the `Box` component if `maxWidth="md"`. */
  boxWidthMd: {
    maxWidth: theme.busbud.breakpoints.values.md,
    [`&.${classes.boxScrollBody}`]: {
      [theme.busbud.breakpoints.down(theme.busbud.breakpoints.values.md + theme.busbud.space.base * 3 * 2)]: {
        maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
      }
    }
  },
  /* Styles applied to the `Box` component if `maxWidth="lg"`. */
  boxWidthLg: {
    maxWidth: theme.busbud.breakpoints.values.lg,
    [`&.${classes.boxScrollBody}`]: {
      [theme.busbud.breakpoints.down(theme.busbud.breakpoints.values.lg + theme.busbud.space.base * 3 * 2)]: {
        maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
      }
    }
  },
  /* Styles applied to the `Box` component if `maxWidth="xl"`. */
  boxWidthXl: {
    maxWidth: theme.busbud.breakpoints.values.xl,
    [`&.${classes.boxScrollBody}`]: {
      [theme.busbud.breakpoints.down(theme.busbud.breakpoints.values.xl + theme.busbud.space.base * 3 * 2)]: {
        maxWidth: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
      }
    }
  },
  /* Styles applied to the `Box` component if `fullWidth={true}`. */
  boxFullWidth: {
    width: `calc(100% - ${theme.busbud.spacing(3 * 2)})`
  },
  /* Styles applied to the `Box` component if `fullScreen={true}`. */
  boxFullScreen: {
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: 'none',
    borderRadius: 0
  }
}));
const defaultTransitionDuration = {
  enter: _transitions.duration.enteringScreen,
  exit: _transitions.duration.leavingScreen
};
function getScrollClassKey(scroll) {
  return `scroll${(0, _capitalizeFirstWord.capitalizeFirstWord)(scroll)}`;
}
function getBoxScrollClassKey(scroll) {
  return `boxScroll${(0, _capitalizeFirstWord.capitalizeFirstWord)(scroll)}`;
}
function getBoxWidthClassKey(maxWidth) {
  if (maxWidth === false) {
    return 'boxWidthFalse';
  }
  return `boxWidth${(0, _capitalizeFirstWord.capitalizeFirstWord)(maxWidth)}`;
}

/**
 * Dialogs inform users about a task and can contain critical information, require decisions, or involve multiple tasks.
 *
 * A Dialog is a type of modal window that appears in front of app content to provide critical information or ask for a decision. Dialogs disable all app functionality when they appear, and remain on screen until confirmed, dismissed, or a required action has been taken.
 *
 * Dialogs are purposefully interruptive, so they should be used sparingly.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-feedback-dialog--page)
 */
const Dialog = /*#__PURE__*/_react.default.forwardRef(function Dialog(props, ref) {
  const {
      BackdropProps,
      BoxProps = {},
      children,
      classes: classesOverrides,
      className,
      disableBackdropClick = false,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClose,
      onEnter,
      onEntered,
      onEntering,
      onEscapeKeyDown,
      onExit,
      onExited,
      onExiting,
      open,
      scroll = 'box',
      TransitionComponent = _Fade.default,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const mouseDownTarget = _react.default.useRef(null);
  const handleMouseDown = event => {
    mouseDownTarget.current = event.target;
  };
  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    }

    // Make sure the event starts and ends on the same DOM element.
    if (event.target !== mouseDownTarget.current) {
      return;
    }
    mouseDownTarget.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const handleModalOnClose = (event, reason) => {
    if (!onClose) {
      return;
    }
    if (reason === 'backdropClick') {
      if (disableBackdropClick) {
        return false;
      }
    }
    if (reason === 'escapeKeyDown') {
      if (disableEscapeKeyDown) {
        return false;
      }
      if (onEscapeKeyDown) {
        onEscapeKeyDown(event);
      }
    }
    onClose(event, reason);
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, (0, _extends2.default)({
    className: cx(classes.root, className),
    BackdropComponent: _Backdrop.default,
    BackdropProps: _objectSpread({
      transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    onClose: handleModalOnClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/_react.default.createElement(TransitionComponent, (0, _extends2.default)({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.container, classes[getScrollClassKey(scroll)]),
    onClick: handleBackdropClick,
    onMouseDown: handleMouseDown,
    "data-testid": "FakeBackdrop"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({
    role: "dialog"
  }, BoxProps, {
    border: "sm",
    boxShadow: "lg",
    boxShadowColor: "subtle",
    bgColor: "background.primary.opaque",
    className: cx(BoxProps.className, classes.box, classes[getBoxScrollClassKey(scroll)], classes[getBoxWidthClassKey(maxWidth)], {
      [classes.boxFullScreen]: fullScreen,
      [classes.boxFullWidth]: fullWidth
    })
  }), children))));
});
var _default = exports.default = Dialog;